import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  CasoTareaService,
  CasoTareaModel,
} from 'src/app/services/casos_tareas.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { VerHistorialComponent } from '../ver-historial/ver-historial.component';

@Component({
  selector: 'casos-archivados',
  templateUrl: './casos-archivados.component.html',
  styleUrls: ['./casos-archivados.component.css'],
})
export class CasosArchivadosComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = [
    'numero_caso',
    'descripcion',
    'tipo_caso',
    'unidad',
    'asignadoA',
    'creadoPor',
    'createdAt',
    'updatedAt',
    'opciones',
  ];
  dataSource = new MatTableDataSource<CasoTareaModel>();
  casos: CasoTareaModel[] = [];
  casosNotFiltered: CasoTareaModel[] = [];
  search: string = '';
  filter_cases: string; //valor de casos a filtrar
  //Textos que cambian si el tipo de caso es externos
  text = {
    Casos: 'Casos',
    casos: 'casos',
  };
  constructor(
    public _casos: CasoTareaService,
    public _users: UserService,
    public dialog: MatDialog
  ) {}
  ngOnInit() {
    let type_case = sessionStorage.getItem('type_case');
    switch (type_case) {
      case 'externos':
        this.filter_cases = 'Asuntos Externos';
        this.text.Casos = 'Solicitudes';
        this.text.casos = 'solicitudes';
        this.displayedColumns = [
          'numero_caso',
          'descripcion',
          'tipo_caso',
          'unidad',
          'asignadoA',
          'creadoPor',
          'createdAt',
          'updatedAt',
          'validar_documento',
          'fecha_realizacion',
          'email_usado',
          'informado_correo',
          'autorizar',
          'patron_fraude',
          'opciones',
        ];

        break;
      case 'inteligencia':
        this.filter_cases = 'Inteligencia';
        break;
      case 'internos':
        this.filter_cases = 'Asuntos Internos';
        break;

      default:
        break;
    }
    console.log(type_case, this.filter_cases);

    this.getCasos(); //cambiar en caso de que se un caso de externos
  }

  // INIT
  async getCasos() {
    var casos: CasoTareaModel[] = await this.httpRequestGetCasos();
    casos = casos.reverse();
    this.casos = await this.filterCasosByArchivados(casos);
    this.casosNotFiltered = this.casos;
    console.log(this.casos);
    this.initializeTable(this.filter(this.casos));
  }

  // HELPERS INIT
  async httpRequestGetCasos() {
    return await this._casos.get().toPromise();
  }

  async filterCasosByArchivados(casos: CasoTareaModel[]) {
    const newcasos = casos.filter((caso: CasoTareaModel) => {
      this._users
        .getUserById(parseInt(caso.creadoPor))
        .subscribe((user: any) => {
          caso.creadoPorc = user.payload.correo;
        });
      return caso.estado === 'Archivado' && caso.unidad == this.filter_cases;
    });

    console.log('newcasos', newcasos);
    return newcasos;
  }

  initializeTable(casos: CasoTareaModel[]) {
    this.dataSource = new MatTableDataSource<any>(casos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  filter(casos: CasoTareaModel[]) {
    casos = casos.filter(
      (caso: CasoTareaModel) =>
        JSON.stringify(caso)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
    return casos;
  }

  // CLICK FUNCTIONS
  filterByClick() {
    this.casos = this.casosNotFiltered.filter(
      (caso: CasoTareaModel) =>
        JSON.stringify(caso)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
  }

  verHistorial(caso: CasoTareaModel) {
    this.dialog.open(VerHistorialComponent, {
      width: '90%',
      data: caso.historial,
      disableClose: true,
      panelClass: 'historial-class',
    });
  }
}
